module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PREMIUM_PLUS_3.e6c7b6bb.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PREMIUM_PLUS_3.png
// module id = 1170
// module chunks = 16